import { createSelector } from 'reselect';
import { fulfillmentMethodOptimizationPLPSelector } from 'selectors/testTarget/offers/fulfillmentMethodOptimizationPLP/fulfillmentMethodOptimizationPLPSelector';

const experienceSelector = createSelector(
    fulfillmentMethodOptimizationPLPSelector,
    fulfillmentMethodOptimizationPLP => fulfillmentMethodOptimizationPLP.experience
);

export { experienceSelector };
